import { Link } from "react-router-dom";
import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";

export default function ReviewsCta() {
  return (
    <section className="sun-glaze bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="bg-secondary-50 rounded-lg border border-secondary-200 p-8 md:p-14 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-3 mb-5">
                <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
                <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                  Add Your Story
                </span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl leading-tight text-foreground-950 font-semibold">
                Your Visit Could Be the Next Story Here
              </h2>
              <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed max-w-2xl">
                Choose an experience, spend a day on a real farm, and share what you find. Every
                review helps a farmer reach more people and keeps these traditions alive.
              </p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <div className="flex flex-wrap lg:justify-end gap-3">
                <a
                  href="#share"
                  className="inline-flex items-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Share Your Experience
                  <i className="ri-chat-quote-line"></i>
                </a>
                <Link
                  to="/experiences"
                  className="inline-flex items-center gap-2 border border-background-300 text-foreground-800 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Explore Experiences
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}